<template>
    <div class="agencies">
        <heading title="Agencies" tag="agency-list-title">
            <export-button class="mr-3"
                           @export="exportList"/>
            <b-button v-if="canCreate"
                      variant="primary"
                      :to="{name:'agencyCreate'}">
                Add Agency
                <b-icon-plus-square/>
            </b-button>
        </heading>

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key === 'status'">
                    {{ getStatusLabel(slotProps.row.item.status) }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'projectCount'">
                    {{ slotProps.row.item.projectCount }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'actions'">
                    <router-link class="btn btn-secondary btn-sm mr-2 btn-icon"
                                 :to="{ name: 'agencyView', params: { agencyId : slotProps.row.item.id}}">
                        <b-icon-eye/>
                    </router-link>
                </div>
            </template>
        </data-table>
    </div>
</template>

<script>
import Vue from 'vue'
import Agency from '@/models/Agency'
import Authorization from '@/providers/Authorization'
import Export from '@/providers/Export'

export default Vue.extend({
    name: 'Agencies',
    data () {
        return {
            agencyFields: Agency,
            fields: [
                { key: 'id', sortable: true, label: 'ID' },
                { key: 'name', sortable: true, label: 'Name' },
                { key: 'abbreviation', sortable: true, label: 'Abbreviation' },
                { key: 'status', sortable: false, label: 'Status' },
                { key: 'projectCount', sortable: true, label: 'Project Count' },
                { key: 'openAuditCount', sortable: false, label: 'Open Audits' },
                { key: 'auditEquipmentIssueCount', sortable: false, label: '# Audit Issues / Violations' },
                { key: 'actions', sortable: false }
            ],
            exportFields: {
                name: 'Name',
                abbreviation: 'Abbreviation',
                status: 'Status'
            },
            canCreate: false,
        }
    },
    computed: {
        filters () {
            return {
                name: { field: 'name', type: 'string', value: null, label: 'Agency Name' }
            }
        }
    },
    created () {
        Authorization.can({ action: 'create', model: 'agency' })
            .then((can) => this.canCreate = can)
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'agency', this.filters, listParams, ['projectCount', 'openAuditCount', 'auditEquipmentIssueCount'])
        },
        getStatusLabel (value) {
            return Agency.getStatusLabel(value)
        },
        removeEntry: async function (item) {
            this.$bvModal.msgBoxConfirm('Would you like to delete this agency? This action cannot be undone.')
                .then(async value => {
                    if (value) {
                        await this.$api.deleteItem(this, 'agency', item)
                        this.$refs.dataTable.refresh()
                    }
                })
        },
        async exportList (type) {
            //  context
            const contextTable = this.$refs.dataTable.getContext()
            const context = contextTable ? {sortBy: contextTable.sortBy, perPage: 100000, currentPage: 1} : null
            this.$api.getItems(this, 'agency', this.filters, context)
                .then((agencies) => {
                    let callback = (key, value) => {
                        switch (key) {
                            case 'status':
                                value = this.getStatusLabel(value)
                                break
                        }
                        return value
                    }
                    //  export
                    Export.exportRecords(agencies, this.exportFields, 'Agencies', type, callback)
                })
        }
    },
})
</script>
